window.contactForm = (params) => {
    return {
        submitting: false,
        init() {
            if (params.additionalData) {
                for (const key in params.additionalData) {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = params.additionalData[key];

                    this.$refs.form.appendChild(input);
                }
            }
        },
        submit(e) {
            e.preventDefault();

            this.submitting = true;

            grecaptcha.ready(() => {
                grecaptcha
                    .execute(process.env.MIX_RECAPTCHA_SITE_KEY, {
                        action: 'verify_contact',
                    })
                    .then((token) => {
                        fetch('/verify-contact-form', {
                            method: 'POST',
                            cache: 'no-cache',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/json',
                                'X-Requested-With': 'XMLHttpRequest',
                                'X-CSRF-Token': params.csrf_token,
                            },
                            body: JSON.stringify({
                                token,
                            }),
                        })
                            .then(async (res) => {
                                if (!res.ok) {
                                    const json = await res.json();
                                    throw new Error(json.message);
                                }

                                return res.json();
                            })
                            .then((res) => {
                                this.$refs.form.submit();
                            })
                            .catch((e) => {
                                this.submitting = false;
                            });
                    });
            });
        },
    };
};
